/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react'
import Head from 'next/head'
import { $config } from '$utils'
import { Anchor, Button } from 'antd'
import { useSelector } from 'react-redux'
import NoSSR from '@/components/rc-no-ssr'
import RBreadCrumb from '@/components/rc-bread-crumb'
import Basic from './modules/car-basic'
import Report from './modules/car-inspect-report'
import CarSold from './modules/car-sold'
import CarProcess from './modules/car-process'
import CarQA from './modules/car-qa'
import Gallery from './modules/car-gallery'
import CarCfg from './modules/car-configuration'
import CarBargain from './modules/car-bargain'
import ConsigmentBanner from './modules/car-consigment-banner'
import { UseIntentOrder } from './modules/intent-modal/order'
import { UseIntentBargain } from './modules/intent-modal/bargain'
import { useScrollPosition } from 'react-use-scroll-position'
import './index.scss'
import {
  initDefaultData, usePageMeta, usePopWin, usePageData
} from './logic'
import { getFirstScreenData } from './service'
import car404Img from '~/img/buy/404.png'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'

const BuyDetail = ({ content, carId }) => {
  // 设置页面名称
  $config.setPageName('car-detail')
  // store 数据解构
  const {
    user: { phone },
    city: {
      ino, city, phone_source, fr, city_name
    }
  } = useSelector(store => store)

  // 车源404 3s跳买车页
  if (!content) {
    useEffect(() => {
      const timeout = setTimeout(() => {
        window.location.href = `https://www.renrenche.com/buy`
      }, 3000)
      return () => { clearTimeout(timeout) }
    })

    return (
      <div className="r-detail-error">
        <div className="r-detail-error__err-img">
          <img src={car404Img} alt="404错误页" />
        </div>
        <h1><strong>OH  NO~ </strong>这个页面开车离开网站了</h1>
        <p>您可以看看别的车 或者 <a href="https://www.renrenche.com">去首页&gt;&gt;</a></p>
      </div>
    )
  }

  // 页面数据
  const basicInfo = content.basic_info
  const { tags } = content // 首屏数据 content
  const { price, sold, log_id } = content?.basic_info

  initDefaultData({ carId })// 存储数据
  // const [fixedDisplay] = useFixedAnchor()// 滚动>40时显示anchor
  const [fixedDisplay, setFixedDisplay] = useState(false)
  const { y } = useScrollPosition()
  useEffect(() => {
    const flag = y>40
    if(fixedDisplay!==flag){
      setFixedDisplay(flag)
    }
   }, [y])
  const [pageMeta] = usePageMeta({ basicInfo, tags: tags || [] })// 页面元信息
  const [otherData, breadOption, servicePriceConfig] = usePageData({ content, carId })// 页面数据
  // usePopGift({ content, carId }) // 15s限时礼包弹窗
  usePopWin({ content, carId }) // 60s弹窗

  // 咨询车况
  const toConsult = () => {
    global.$rbl.push({
      event: 'car-detail_tophover_vehiclecondition',
      content: {
        param: '咨询-PC-详情页-6'
      }
    })
    const submitParams = {
      mobile_number: phone || '',
      sub_product: '咨询',
      phone_source: `${fr}${ino ? '_异地' : ''}`,
      submit_sources: '咨询-PC-详情页-6'
    }
    const otherParams = { ino, basicInfo }
    new UseIntentOrder({ intentType: 'consult', submitParams, otherParams }).open()
  }

  // 砍价
  const toBargain = () => {
    global.$rbl.push({
      event: 'car-detail_tophover_bargain',
      content: {
        param: '砍价-PC-详情页-3'
      }
    })
    const submitParams = {
      phone: phone || '',
      owner_price: `${price}`,
      source: `${fr}${ino ? '_异地' : ''}`,
      submit_sources: '砍价-PC-详情页-3'
    }
    const otherParams = { basicInfo }
    new UseIntentBargain({ submitParams, otherParams }).open()
  }
  const gaClick = (name) => {
    global.$rbl.push(`car-detail_tophover_${name}_click`)
  }

  useEffect(() => {
    global.$rbl.push({
      event: 'detail_pageview',
      content: {
        dfr: window.location.pathname.split('/')[4] ? window.location.pathname.split('/')[4] : '',
        log_id: log_id || '',
        car_id: carId,
        cityName: city_name
      }
    })
  }, [])

  return (
    <>
      <Head>
        <title>{pageMeta.title}</title>
        <meta name="keywords" content={pageMeta.keywords} />
        <meta name="description" content={pageMeta.description} />
      </Head>
      <div className="r-detail-wraper">
        <NoSSR>
          <div className={`r-detail-wraper__anchor ${!fixedDisplay ? 'anchor-fixed' : ''}`}>
            <Anchor
              offsetTop={-2}
              className="anchor-content clearfix"
              onClick={(e, link) => {
                e.preventDefault()
                let gaName = ''
                switch (link.title) {
                  case '基本信息':
                    gaName = 'basicinfor'
                    break
                  case '车检报告':
                    gaName = 'certificate'
                    break
                  case '图片合集':
                    gaName = 'descriptionimages'
                    break
                  case '车检报告详情':
                    gaName = 'reports'
                    break
                  case '配置参数':
                    gaName = 'configuration'
                    break
                  default:
                    break
                }
                gaClick(gaName)
              }}
            >
              <Anchor.Link className="anchor-link" href="#top" title="基本信息" />
              <Anchor.Link className="anchor-link" href="#part-report" title="车检报告" />
              <Anchor.Link className="anchor-link" href="#part-imgs" title="图片合集" />
              <Anchor.Link className="anchor-link" href="#part-config" title="配置参数" />
              <div className="anchor-right">
                {!sold && (
                <>
                  <Button className="intent-btn consult" onClick={toConsult}>咨询车况</Button>
                  <Button className="intent-btn bargain" onClick={toBargain}>砍价</Button>
                </>
                )}
                <span className="intent-phone">{phone_source?.buyer}</span>
              </div>
            </Anchor>
          </div>
        </NoSSR>
        {/* 面包屑 */}
        <RBreadCrumb breadOption={useMemo(()=>{return breadOption},[breadOption])} />
        {/* 基础信息 */}
        <Basic basic={useMemo(()=>{return { ...content, carId }},[content,carId])}   servicePriceConfig={servicePriceConfig}/>
        {/* 车检报告 */}
        <div id="part-report" name="part-report" />
        <Report basic={{ ...content, carId }} another={useMemo(()=>{return { ...otherData }},[otherData])}/>

        <NoSSR>
          {/* 车辆详情-图片合集 */}
          <div id="part-imgs" name="part-imgs" />
          <LazyLoad offset={100} height={3893}><Gallery another={useMemo(()=>{return { ...otherData }},[otherData])} basic={{ ...content, carId }} /></LazyLoad>

          {/* 中间砍价模块 */}
          <LazyLoad offset={100} height={100}><CarBargain carInfo={useMemo(()=>{return { ...content.basic_info, tags: content.tags || [], carId }},[content,tags])} /></LazyLoad>

          {/* 配置参数 */}
          <div id="part-config" name="part-config" />
          <LazyLoad offset={100} height={588}><CarCfg carId={useMemo(()=>carId,[carId])} basicInfo={useMemo(()=>{return basicInfo},[basicInfo])} /></LazyLoad>

          {/* 类似车辆成交 */}
          <LazyLoad offset={100} height={230}><CarSold carId={useMemo(()=>carId,[carId])} /></LazyLoad>

          {/* 买车流程 */}
          <CarProcess/>

          {/* 严选车是什么？ */}
          {basicInfo.sell_on_consignment === 1 ? <CarQA carId={carId} introductions={otherData?.introduction} /> : <></>}

          {/* 我要卖车 */}
          <LazyLoad offset={100}>
          <div
            className="r-detail-wraper__bottom-sale"
            data-exposure="car-detail_bottomsellcar_display"
            data-click="car-detail_bottomsellcar_click"
          >
            <p className="txt"> <span>好车不和坏车一起卖 好车<span className="high">卖好价</span></span></p>
            <Link href="/sell"><a className="btn">我要卖车</a></Link>
          </div>
          </LazyLoad>

          {/* 严选商城悬浮概念条 */}
          {basicInfo.sell_on_consignment === 1 ? <ConsigmentBanner /> : <></>}
        </NoSSR>
      </div>
    </>
  )
}

BuyDetail.getInitialProps = async ({ ctx }) => {
  let carDetail
  try {
    carDetail = await getFirstScreenData({ cid: ctx.query.id, city_name: 'bj', caller: 'pc' })
    return {
      content: { ...carDetail?.data?.content },
      carId: ctx.query.id
    }
  } catch (err) {
    console.log('BuyDetail.getInitialProps---err---', err)
    // ctx.$logger.error('[BuyDetail.getInitialProps',err)
    return {
      content: null,
      carId: ctx.query.id
    }
  }
}

export default BuyDetail
